export default __webpack_public_path__ + "static/media/Digital-Organization.6975552c.svg";